let MessageBag = require('../utils/message-bag');

class ErrorBag extends MessageBag {
  /**
   * Add the given key-value pair to the bag
   *
   * @param {String} key
   * @param {mixed} value
   */
  add (key, value) {
    super.put(key, value);
  }

  /**
   * Fill the error bag with the given messages
   *
   * @param {Array} messages
   */
  fill (messages) {
    // Laravel 5.5+ support
    if (messages.errors) {
      this.setGlobalMessage(messages.message);
      messages = messages.errors;
    }

    super.fill(messages);
  }

  /**
   * Set the global message
   *
   * @param {String} message
   */
  setGlobalMessage (message) {
    this.put(
      this.getGlobalMessageKey(),
      message
    );
  }

  /**
   * Get the global message key
   *
   * @return {String}
   */
  getGlobalMessageKey () {
    return '_global';
  }
}

module.exports = ErrorBag;
